// Reusable Promo Popup functionality
(function() {
  const shownPopups = new Set();

  // Defined unconditionally so inline trigger scripts can call them before
  // DOMContentLoaded (the popup HTML is rendered after this script tag).

  window.showPromoPopup = function(popupId, force) {
    var storageKey = 'promo-shown-' + popupId;
    if (!force && sessionStorage.getItem(storageKey)) return;
    const popup = document.getElementById(popupId);
    if (popup && !shownPopups.has(popupId)) {
      popup.style.display = 'block';
      shownPopups.add(popupId);
      if (!force) sessionStorage.setItem(storageKey, '1');
    }
  };

  // Spend threshold tracking for promo popups
  window.PromoThresholdTracker = {
    thresholds: {},

    register: function(popupId, thresholdAmount, currencyCode) {
      this.thresholds[popupId] = {
        amount: thresholdAmount,
        currency: currencyCode
      };
    },

    // Fire each time the cart total crosses up to the threshold; re-arm when it drops below.
    // Forced show (no per-session de-dup): this trigger is not "once per session" (unlike
    // Page Visit). The initial previousTotal is the on-load cart total, so an already-eligible
    // cart on load does not fire.
    onCartUpdate: function(previousTotal, newTotal) {
      Object.keys(this.thresholds).forEach(popupId => {
        const threshold = this.thresholds[popupId];
        if (previousTotal < threshold.amount && newTotal >= threshold.amount) {
          window.showPromoPopup(popupId, true);
        } else if (newTotal < threshold.amount) {
          shownPopups.delete(popupId);
        }
      });
    }
  };

  // Collection-membership tracking for popups (mirrors PromoThresholdTracker).
  window.PromoCollectionTracker = {
    registrations: {}, // popupId -> { productIds, quantity, eligible: bool|null }

    register: function (popupId, productIds, quantity) {
      this.registrations[popupId] = {
        productIds: productIds || [],
        quantity: quantity && quantity > 0 ? quantity : 1,
        eligible: null // baseline set on first evaluation; transitions drive the popup
      };
    },

    // Fire each time the cart transitions ineligible -> eligible; re-arm on the reverse.
    // The null baseline means an already-eligible cart on page load does NOT fire (no popup
    // on mere navigation). Forced show (no per-session de-dup): not "once per session".
    onCartUpdate: function (cart) {
      var items = (cart && cart.items) || [];
      Object.keys(this.registrations).forEach(function (popupId) {
        var reg = window.PromoCollectionTracker.registrations[popupId];
        var matched = 0;
        items.forEach(function (item) {
          if (reg.productIds.indexOf(item.product_id) !== -1) matched += item.quantity;
        });
        var nowEligible = matched >= reg.quantity;
        if (reg.eligible === false && nowEligible) {
          window.showPromoPopup(popupId, true);
        } else if (reg.eligible === true && !nowEligible) {
          shownPopups.delete(popupId);
        }
        reg.eligible = nowEligible;
      });
    }
  };

  // Track cart total changes via the cart:updated event dispatched by cart.js and product-form.js
  // Initial cart total is injected by metaobject-popups.liquid to avoid an extra HTTP request
  let previousCartTotal = window.__initialCartTotal || 0;

  document.addEventListener('cart:updated', function(event) {
    const cart = event.detail && event.detail.cart ? event.detail.cart : null;
    const newTotal = cart ? cart.total_price : null;
    if (newTotal !== null) {
      window.PromoThresholdTracker.onCartUpdate(previousCartTotal, newTotal);
      previousCartTotal = newTotal;
    }
    if (cart) {
      window.PromoCollectionTracker.onCartUpdate(cart);
    }
  });

  // Set up close buttons and overlay dismiss after the DOM is fully parsed
  function setupPopups() {
    const promoPopups = document.querySelectorAll('.promo-popup');
    if (!promoPopups.length) return;

    promoPopups.forEach(popup => {
      const popupId = popup.id;
      const closeButton = document.getElementById('close-' + popupId);
      const addToCartButton = popup.querySelector('.promo-add-to-cart');

      if (closeButton) {
        closeButton.addEventListener('click', function(e) {
          e.preventDefault();
          const p = document.getElementById(popupId);
          if (p) p.style.display = 'none';
        });
      }

      popup.addEventListener('click', function(e) {
        if (!e.target.closest('.site-popup')) {
          popup.style.display = 'none';
        }
      });

      if (addToCartButton) {
        addToCartButton.addEventListener('click', function(e) {
          e.preventDefault();

          const variantId = this.getAttribute('data-variant-id');
          if (!variantId) {
            console.error('No variant ID found');
            return;
          }

          const spinner = this.querySelector('.loading-overlay__spinner');
          this.setAttribute('disabled', 'disabled');
          if (spinner) spinner.classList.remove('hidden');

          const formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', 1);

          const config = {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/javascript'
            },
            body: formData
          };

          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          if (cart) {
            formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
          }

          fetch('/cart/add.js', config)
            .then(response => response.json())
            .then(response => {
              if (response.status) {
                throw new Error(response.description || response.message || 'Error adding to cart');
              }

              popup.style.display = 'none';
              this.removeAttribute('disabled');
              if (spinner) spinner.classList.add('hidden');

              if (cart) cart.renderContents(response);

              fetch('/cart.js')
                .then(response => response.json())
                .then(cartData => {
                  const freeShippingWidgets = document.getElementsByClassName('free-shipping-progress-bar-widget');
                  for (let widget of freeShippingWidgets) {
                    widget.setAttribute('data-cart-total', cartData.items_subtotal_price);
                  }
                })
                .catch(error => console.error('Error fetching cart:', error));
            })
            .catch(error => {
              console.error('Error adding product to cart:', error);
              // Reuse the theme's translated cart-error string (window.cartStrings.error is
              // defined in layout/theme.liquid and localised for every published language).
              // English literal kept only as a fallback if cartStrings hasn't loaded.
              alert((window.cartStrings && window.cartStrings.error) || 'Sorry, there was an error adding the item to your cart. Please try again.');
              this.removeAttribute('disabled');
              if (spinner) spinner.classList.add('hidden');
            });
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupPopups);
  } else {
    setupPopups();
  }
})();
